module.exports = __webpack_public_path__ + "static/media/pg.19c149e3.svg";